import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import router from "@/router";

const app = createApp(App)

app.use(ElementPlus)
app.use(Toast)
app.use(router)
app.mount('#app')